import React from "react";
import { IDS } from "../../../utils/IDS";
const Banner = ({backgroundimage}) => {
  return (
    <section className="Banner">
      <div className="container-fluid ">
        <div className="saguruaprpadiv">
          <img
            className="bannerimg"
           src={`${IDS.IMG_URL}${backgroundimage}`}
            alt="sadguru-banner"
          />
        </div>
      </div>
    </section>
  );
};

export default Banner;
